<i18n
  src="@/locales/components/views/agro_exporter/production/query_container_export/exportation_status.yml"
  lang="yaml"
></i18n>
<template>
  <span
    :class="[
      'inline-flex items-center px-2 py-0.5 rounded text-sm font-medium',
      exportation_status.gui
    ]"
  >
    {{ exportation_status.label }}
  </span>
</template>

<script>
export default {
  name: "AEProductionQueryContainerExportExportationStatus",
  props: { status_id: {}, prepend_label: { default: "" } },
  computed: {
    exportation_status: function () {
      if (this.status_id == 0)
        return {
          gui: "bg-yellow-100 text-yellow-800",
          label: `${this.prepend_label} ${this.$t("labels.in_preparation")}`
        };
      if (this.status_id == 1)
        return {
          gui: "bg-blue-100 text-blue-800",
          label: `${this.prepend_label} ${this.$t("labels.in_transit")}`
        };
      if (this.status_id == 2)
        return {
          gui: "bg-green-100 text-green-800",
          label: `${this.prepend_label} ${this.$t("labels.arrived")}`
        };
      return {};
    }
  }
};
</script>
